<div class="container-right-main fluid-container">
    <app-feedback-header [title]="'Request Details'" [showButton]="false" [headerData]="headerData"
        (backClick)="goBack()" (buttonClick)="viewDetailsDescription()" (assignClick)="openAssignTicketToDialog()">
    </app-feedback-header>

    <app-feedback-comment-timeline #timelineRef [requestId]="requestId" [requestType]="requestDetail?.type"
        [downloadContext]="'request'" [historyDetails]="historyDetails" [feedbackStatusList]="statusList"
        [selectedFeedbackStatus]="selectedStatus" [commentText]="commentText" [isSubmitting]="isSubmitting"
        [isLoading]="isLoading" (statusChange)="onStatusChange($event)" (submitComment)="addComment()"
        (commentTextChange)="commentText = $event" (filesChanged)="onFilesChanged($event)">
    </app-feedback-comment-timeline>
</div>